var Config = {
  apiBaseURL: '/auth',
  notifySetting: {
    position: 'top-right',
    timeout: 5000,
  },
}

module.exports = Config